import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { repiDomain } from '../../../../store/repiStore';
import { formatNumber } from '../../repiUtils';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import RepiScore from './repiScore';
import RepiSemaphore from './repiSemaphore';

import '../../repi.scss';

class RepiContractsSummary extends React.Component {
    get isSk() { return this.props.user.authentication.profile.agentLanguage === "sk-SK"}
    get locale() { return get(this.props, "activeLanguage.code"); }

    render() {
        const { data } = this.props;

        if (isNullOrUndefined(data) || isNullOrUndefined(data.paymentHistory) ||
            isNullOrUndefined(data.paymentHistory.repiScore) && isNullOrUndefined(data.paymentHistory.creditScore)) {
            return null;
        }

        const lastUpdate = get(data, "paymentHistory.summary.dataEndDateFormatted");

        return (
            <div className="repi-payment-history-1em-wrapper">
                <div className="repi-subsection-header repi-section-last-update-wrapper">
                    <div><Translate id="Repi.Report.PaymentHistory.RepiContracts" /></div>
                    {!isNullOrUndefined(lastUpdate) && <div className="repi-last-update">
                        <Translate id="Repi.Report.LastUpdate" />:&nbsp;{lastUpdate}
                    </div>}
                </div>
                <div className="columns is-desktop is-multiline repi-score-container">
                    <div className="column">
                        <div className="columns repi-score-container-left">
                            {!data.paymentHistory.isSubject && this.renderScore(data)}
                            {this.renderPaymentSummary(data)}
                        </div>
                    </div>
                    {this.renderPaymentHistory(data)}
                </div>
            </div>
        );
    }

    renderScore = (data) => {
        if (isNullOrUndefined(data.paymentHistory.repiScore) && isNullOrUndefined(data.paymentHistory.creditScore))
            return null;

        const isSemaphore = !isNullOrUndefined(data.paymentHistory.creditScore);

        return (
            <div className="column">
                <div className={classnames("container repi-container-bordered", { "repi-semaphore-container": isSemaphore })}>
                    {data.paymentHistory.repiScore && <RepiScore score={data.paymentHistory.repiScore} />}
                    {isSemaphore && <RepiSemaphore semaphore={data.paymentHistory.creditScore} />}
                </div>
            </div>
        );
    }

    renderPaymentSummary = (data) => {
        if (isNullOrUndefined(data.paymentHistory) || isNullOrUndefined(data.paymentHistory.summary))
            return null;

        return (
            <div className="column">
                <div className="container repi-container-bordered repi-money">
                    <table className="no-border">
                        <tbody>
                            {!isNullOrUndefined(data.paymentHistory.summary.overdue) && <tr height="50%">
                                <td>
                                    {this.renderTotalAmount(this.props.translate("Repi.Report.PaymentHistory.TotalAmountOverdue"),
                                        data.paymentHistory.summary.overdue[`amount${(this.isSk ? "Eur" : "Czk")}`],
                                        this.isSk ? "EUR" : "CZK")}
                                </td>
                            </tr>}
                            {!isNullOrUndefined(data.paymentHistory.summary.remainingCollections) && <tr height="50%">
                                <td>
                                    {this.renderTotalAmount(this.props.translate("Repi.Report.PaymentHistory.TotalAmountRecovered"),
                                        data.paymentHistory.summary.remainingCollections[`amount${(this.isSk ? "Eur" : "Czk")}`],
                                        this.isSk ? "EUR" : "CZK")}
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderPaymentHistory = (data) => {
        if (isNullOrUndefined(data.paymentHistory) || isNullOrUndefined(data.paymentHistory.detail) ||
            isNullOrUndefined(data.paymentHistory.detail.contracts)) {
            return null;
        }

        const productSummary = this.getProducts(data.paymentHistory.detail.contracts);

        return (
            <div className="column">
                <div className="repi-products">
                    <div className="container repi-container-bordered">
                        <table>
                            <colgroup>
                                <col width="70%" />
                                <col width="15%" />
                                <col width="15%" />
                            </colgroup>
                            <thead>
                                <tr style={{fontWeight: 'bold'}}>
                                    <td><Translate id="Repi.Report.PaymentHistory.Products" /></td>
                                    <td className="align-right"><Translate id="Repi.Report.PaymentHistory.Opened" /></td>
                                    <td className="align-right"><Translate id="Repi.Report.PaymentHistory.Closed" /></td>
                                </tr>
                            </thead>
                            <tbody>
                                {productSummary.map((product, index) => (
                                    <tr key={index}>
                                        <td>{product.name}</td>
                                        <td className="align-right">{product.opened}</td>
                                        <td className="align-right">{product.closed}{product.other > 0 ? "*" : ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                            {data.paymentHistory.summary && <tfoot>
                                <tr style={{fontWeight: 'bold'}}>
                                    <td><Translate id="Repi.Report.PaymentHistory.TotalContractsAndCollections" /></td>
                                    <td className="align-right">{`${data.paymentHistory.summary.openContracts} / ${data.paymentHistory.summary.openCollections}`}</td>
                                    <td className="align-right">{`${data.paymentHistory.summary.closedContracts} / ${data.paymentHistory.summary.closedCollections}`}</td>
                                </tr>
                            </tfoot>}
                        </table>
                        {productSummary.filter(f => f.other > 0).length > 0
                            ? <div style={{ fontSize: "0.6em" }}>* <Translate id="Repi.Report.PaymentHistory.MissingOpenCloseInformation" /></div>
                            : null}
                    </div>
                </div>
            </div>
        );
    }

    renderTotalAmount = (header, amount, currency) => {
        return (
            <div className="container">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div className="header">{header}</div>
                                <div className="line"></div>
                                <div className="repi-money-text">{`${formatNumber(amount, this.locale)} ${currency}`}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    getProducts = (contracts) => {
        let products = [];

        if (!contracts)
            return products;

        contracts.map((contract) => {
            if (!products.includes(contract.productCode))
                products.push(contract.productCode);
        });

        let productsList = [];
        products.map((code) => {
            let opened = 0, closed = 0, other = 0;

            contracts.map(x => {
                if (x.productCode == code) {
                    if (!isNullOrUndefined(x.isContractOpen)) {
                        if (x.isContractOpen === true)
                            opened += 1;
                        else
                            closed += 1;
                    } else
                        other += 1;
                }
            });

            productsList.push({
                code: code,
                name: this.props.translate("Repi.Report.PaymentHistory.Filter.ContractType." + code),
                opened: opened,
                closed: closed,
                other: other
            });
        });

        return productsList;
    }
}

export default connect(
    state => ({
        domain: { [repiDomain.currencies]: state.domain[repiDomain.currencies] },
        user: state.userContext
    }),
    null
)(withLocalize(withRouter(RepiContractsSummary)));
